const Footer = () => {
  return (
    <div className="footer">
      &copy; Paragon 2022, all rights reserved
    </div>
  );
}

export default Footer;